import UserFeedback from "../../components/UserFeedback";

const UserFeedbackPage = () => {
  return <UserFeedback />;
};

export default UserFeedbackPage;
